export default __webpack_public_path__ + "static/media/linkedin.e32e88fd.svg";